import NameTranslationParamMapper from "../../core/service/translations/NameTanslationParamMapper";
import { parseBooleanValue } from "../../util";
import { IOrganisationIndexCategory } from "../model/OrganisationIndexCategory";

const OrganisationIndexCategoryParamMapper = (
  item: IOrganisationIndexCategory
) => {
  return {
    ...item,
    valid: parseBooleanValue(item.valid),
    nameTranslations: item.nameTranslations.map((elem) =>
      NameTranslationParamMapper(elem)
    )
  };
};

export default OrganisationIndexCategoryParamMapper;
